function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from "react";
import HubspotForm from "react-hubspot-form";
import DataLayerEventTypes from "constants/data-layer-event-types";
import { fireGtmEvent } from "client/services/gtm-service/gtm-service";
import { HUBSPOT_FORM_SUBMIT_CLICKED, HUBSPOT_FORM_READY } from "constants/bigbrain-event-types";
import MondayLoaderComponent from "components/core/loader/monday-loader-component";
import { trackEvent } from "services/bigbrain-service";
import { PORTAL_ID } from "client/services/hubspot-service/contact-form-config";
import { generateHiddenData } from "client/services/hubspot-service/hubspot-service";
import { withAbTests } from "contexts/ab-tests-context";
import { withGenericConfig } from "contexts/generic-config-context";
import jquery from "jquery";
import { HUBSPOT_API_COMPANY_SIZE, PII_PARAMS } from "client/services/hubspot-service/hubspot-constants";
import mapValues from "lodash/mapValues";
import keyBy from "lodash/keyBy";
import * as Sentry from "@sentry/nextjs";
import { StyledContactSalesHubspotFormComponent } from "./contact-sales-hubspot-form-component.scss";
import omit from "lodash/omit";
const ContactSalesHubspotFormComponent = (props)=>{
    const { formId, formMinHeight, withPrivacyNotice, source, abTests, cookies, cloudfrontViewerCountry } = props;
    const renderLoadingState = ()=>/*#__PURE__*/ _jsx("div", {
            className: "monday-loader-wrapper",
            children: /*#__PURE__*/ _jsx(MondayLoaderComponent, {})
        });
    useEffect(()=>{
        // needed for Hubspot form to send submit callback
        window.jQuery = window.jQuery || jquery;
    }, []);
    const onReady = ()=>{
        // We attach visitor_id as hidden field so we can track from
        // which LPs users make the Hubspot form submissions
        const hiddenData = generateHiddenData({
            withPrivacyNotice,
            source,
            abTests,
            cookies,
            cloudfrontViewerCountry
        });
        hiddenData.forEach((data)=>{
            const hiddenField = document.querySelector(`input[name="${data.name}"]`);
            if (hiddenField) {
                hiddenField.value = data.value;
            }
        });
        trackEvent(HUBSPOT_FORM_READY, {
            kind: formId
        });
    };
    const onSubmit = (formData)=>{
        var _formData_find;
        const companySize = formData === null || formData === void 0 ? void 0 : (_formData_find = formData.find((field)=>field.name === HUBSPOT_API_COMPANY_SIZE)) === null || _formData_find === void 0 ? void 0 : _formData_find.value;
        fireGtmEvent(DataLayerEventTypes.HUBSPOT_FORM_SUBMITTED, {
            formId
        });
        let data;
        try {
            data = omit(_object_spread_props(_object_spread({}, mapValues(keyBy(formData, "name"), "value")), {
                leadsource: source
            }), [
                ...PII_PARAMS,
                "hs_context"
            ]);
        } catch (e) {
            Sentry.captureException(e);
        }
        trackEvent(HUBSPOT_FORM_SUBMIT_CLICKED, {
            kind: formId,
            info1: companySize,
            data
        });
    };
    return /*#__PURE__*/ _jsx(StyledContactSalesHubspotFormComponent, {
        className: "contact-sales-hubspot-form-component",
        style: {
            minHeight: formMinHeight
        },
        children: /*#__PURE__*/ _jsx(HubspotForm, {
            portalId: PORTAL_ID,
            formId: formId,
            loading: renderLoadingState(),
            onReady: onReady,
            cssClass: "hbspt-form",
            onSubmit: onSubmit,
            translations: {
                en: {
                    required: "Required"
                }
            }
        })
    });
};
export default withAbTests(withGenericConfig(ContactSalesHubspotFormComponent));
